/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Structure:
          url       => router path
          name      => name to display in sidebar
          slug      => router path name
          icon      => Feather Icon component/icon name
          tag       => text to display on badge
          tagColor  => class to apply on badge element
          i18n      => Internationalization
          submenu   => submenu of current item (current item will become dropdown)
                        NOTE: Submenu items don't have any icon (you can add one if needed)
          isDisabled => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import TCVelikClient from '@/TCVelikClient/TCVelikClient.js';

var sideItems = [
  // Learn Section
  {
    header: "Learn",
    i18n: "Learn"
  },
  {
    url: '/pages/record',
    name: "SOP Editor",
    slug: "SOP Editor",
    i18n: "SOPEditor",
    icon: "CrosshairIcon",
    ShowForGuestUser: true
  },
  {
    url: '/pages/home',
    name: "DiscoverImprove",
    slug: "Read",
    i18n: "DiscoverImprove",
    icon: "BookIcon",
    ShowForGuestUser: true
  },
  {
    url: '/pages/search',
    name: "Search",
    slug: "search",
    i18n: "Search",
    icon: "SearchIcon",
    ShowForGuestUser: false
  },
  {
    url: '/pages/analytics',
    name: "Analytics",
    slug: "dashboardAnalytics",
    icon: "BarChartIcon",
    i18n: "Analytics",
    ShowForGuestUser: false,
    submenu: [{
      name: "Overview",
      slug: "analytics",
      url:"/pages/analyticsOverview",
      icon: "EditIcon",
      i18n: "Overview",
      ShowForGuestUser: false
    }]

  },
  {
    url: "/dashboard/spaces",
    name: "Spaces",
    slug: "spaces",
    tagColor: "warning",
    icon: "HeartIcon",
    i18n: "Spaces",
    ShowForGuestUser: true,
    submenu: [{
      url: '/pages/spaces/manage',
      name: "SpaceManager",
      slug: "spaceManager",
      icon: "EditIcon",
      i18n: "SpaceManager",
      ShowForGuestUser: true
    }]
  },
  // Work Section
  {
    header: "Work",
    i18n: "Work"
  },
  {
    url: '/pages/calendar',
    name: "Company Calendar",
    slug: "calendar",
    icon: "CalendarIcon",
    i18n: "Company Calendar",
    ShowForGuestUser: true
  },
  // Administration Section
  {
    header: "Administration",
    i18n: "Administration"
  },
  {
    url: '/pages/forms',
    name: "Forms",
    slug: "forms",
    icon: "FileTextIcon",
    i18n: "Forms",
    ShowForGuestUser: false
  },
  //{
  //  url: '/pages/process-runs',
  //  name: "Process Runs",
  //  slug: "process-runs",
  //  icon: "ActivityIcon",
  //  i18n: "Process Runs",
  //  ShowForGuestUser: false
  //},
  //{
  //  url: '/pages/process-templates',
  //  name: "Process Templates",
  //  slug: "process-templates",
  //  icon: "FileTextIcon",
  //  i18n: "Process Templates",
  //  ShowForGuestUser: false
  //},
  //{
  //  url: '/pages/process-executions',
  //  name: "Process Executions",
  //  slug: "process-executions",
  //  icon: "PlayIcon",
  //  i18n: "Process Executions",
  //  ShowForGuestUser: false
  //},
  {
    url: '/pages/signals',
    name: "Signals Management",
    slug: "signalsView",
    icon: "ActivityIcon",
    i18n: "SignalsManagement",
    ShowForGuestUser: false
  },
  {
    url: "https://chromewebstore.google.com/detail/tcvelik-assistant/cfjhapiajpbhemmjjjhjppknflfbhmcj?authuser=1&hl=en-GB",
    name: "Chrome Extension",
    slug: "chrome-extension",
    tagColor: "warning",
    icon: "ChromeIcon",
    i18n: "GetTheExtention",
    ShowForGuestUser: true,
    IsAbsolute: true
  },
];

async function fillMenu() {
  var req = JSON.stringify({
    query: `query Spaces {
  spaces(order: { title: ASC }, where: { hideFromSidebar: {eq:false} }) {
    title
    id
    icon
    urlName
    hideFromSidebar
  }
}`
  });
  try {

    var spacesItem = sideItems.find(item => item.name === "Spaces");

    if (spacesItem.submenu.length < 2) {
      var result = await TCVelikClient.PostRelative("/api/graphql", req, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      });

      if (result && result.data && result.data.data && result.data.data.spaces) {
        if (spacesItem && !spacesItem.LoadCompleted) {
          // Populate the submenu with the spaces
          spacesItem.submenu = [
            ...spacesItem.submenu,
            ...result.data.data.spaces.map(space => ({
              url: '/pages/space/' + (space.slug || space.id),
              name: space.title,
              slug: space.slug || space.id,
              icon: space.icon || 'FolderIcon',
              /*i18n: 'Space_' + space.id,*/
              ShowForGuestUser: true,
            }))
          ];
          spacesItem.LoadCompleted = true;
        }
      }
    }

    // Return the updated sideItems array
    return sideItems;
  } catch (error) {
    console.error('Error fetching menu data:', error);
    return sideItems; // Return the default sideItems even if there's an error
  }
}


async function fillAnalytics() {
  var req = JSON.stringify({
    query: `query SavedAnalyticsQuery {
    savedAnalyticsQuery {
        name,
        url
    }
}`
  });
  try {
    var analyticsQueryItem = sideItems.find(item => item.name === "Analytics");

    if (analyticsQueryItem.submenu.length < 2) {
      var result = await TCVelikClient.PostRelative("/api/graphql", req, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      });

      if (result && result.data && result.data.data && result.data.data.savedAnalyticsQuery) {
        if (analyticsQueryItem && !analyticsQueryItem.LoadCompleted) {
          // Populate the submenu with the spaces
          analyticsQueryItem.submenu = [
            ...analyticsQueryItem.submenu,
            ...result.data.data.savedAnalyticsQuery.map(query => ({
              url: '/pages/analytics/' + query.url,
              name: query.name,
              slug: query.name || query.url,
              icon: query.icon || 'FolderIcon',
              /*i18n: 'Space_' + space.id,*/
              ShowForGuestUser: true,
            }))
          ];
          analyticsQueryItem.LoadCompleted = true;
        }
      }
    }

    // Return the updated sideItems array
    return sideItems;
  } catch (error) {
    console.error('Error fetching menu data:', error);
    return sideItems; // Return the default sideItems even if there's an error
  }
}


export default {
  fillMenu: fillMenu,
  fillAnalytics: fillAnalytics
};
